import type { IFileBasedExamAttemptResponse } from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { finish } from "@api/courses/exams/fileBased/attempts/finish/api";
import { latest } from "@api/courses/exams/fileBased/attempts/latest/api";
import { fileBasedExamAttemptSubmissions } from "@api/courses/exams/fileBased/attempts/submissions/api";

const postApis = createPostApi<
  IApiResponse<IFileBasedExamAttemptResponse>,
  IPathBaseParam,
  undefined
>("courses.exams.fileBased.attempt");
const getApis = createGetApi<
  IApiResponse<IFileBasedExamAttemptResponse>,
  IPathByIdParam,
  object
>("courses.exams.fileBased.attempt");

export const attempt = {
  ...getApis,
  ...postApis,
  finish,
  latest,
  fileBasedExamAttemptSubmissions,
};
